import { compose } from 'redux';
import { curry, property } from 'lodash-es';
import { map, propEq, propFromSelector } from '../utils';
import { jsonApi } from '../http-request';

const collection = jsonApi.selectors.collection('offers');
const findResource = jsonApi.findResource(collection);

const findResourceAndHydrate = curry((fn, state) =>
  compose(
    jsonApi.utils.hydrate(state),
    findResource(fn)
  )(state)
);

const createFacade = selector => {
  const propFromResource = propFromSelector(selector);

  return {
    id: propFromResource('id'),
    action: propFromResource('action'),
    category: propFromResource('category'),
    company: propFromResource('company'),
    description: propFromResource('description'),
    detail: propFromResource('detail'),
    link: propFromResource('link'),
    logoId: propFromResource('logo_id'),
    trackingId: propFromResource('tracking_id'),
    subcategory: propFromResource('subcategory'),
    order: propFromResource('order'),
  };
};

export const byId = id =>
  createFacade(findResourceAndHydrate(propEq('id', String(id))));

export const all = compose(
  map(byId),
  map(property('id')),
  collection
);
